import { filter } from 'lodash';

// Sorting functions
export function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// Filtering function
export function applySortFilter(array = [{}], comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.covered_entity.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

// Stats calculation
export function calculateContractStats(contracts) {
  return {
    totalAgreements: contracts.length,
    createdAgreements: contracts.filter((contract) => contract.status === 'Created').length,
    signedAgreements: contracts.filter((contract) => contract.status === 'Signed').length,
  };
}

// Status color helper
export function getStatusColor(status, theme) {
  const statusColors = {
    Created: theme.palette.warning.main,
    Signed: theme.palette.success.main,
    default: theme.palette.text.primary,
  };
  return statusColors[status] || statusColors.default;
}
